import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './components.css';
import loading from '../assets/loading.gif';

export default function ProjectsContent() {
  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(function() {
    axios
      .get('https://akulweb.herokuapp.com/get-projects')
      .then(res => {
        setIsLoading(false);
        setProjects(res.data);
      })
      .catch(err => console.log(err));
  }, []);

  if (!isLoading) {
    return (
      <div>
        <h3 className='oswald mt-2 mb-3'>projects</h3>
        {projects.reverse().map(project => (
          <div className='project mt-2'>
            <h5>{project.name}</h5>

            <small>
              <b>Description:</b> {project.description}
            </small>
            <br />
            <small>
              <b>Link: </b>
              <a href={project.link}>{project.link}</a>
            </small>
          </div>
        ))}
      </div>
    );
  } else {
    return (
      <div>
        <h3 className='oswald mt-2 mb-3'>projects</h3>
        <center>
          <img src={loading} alt='loading' className='loading' />
        </center>
      </div>
    );
  }
}
